'use client';
import React, { ReactNode } from 'react';

interface UpscaleWrapperProps {
  children: ReactNode;
  isUpscaled?: boolean;
  upscaleFactor?: number;
  className?: string;
  showBorder?: boolean;
  state?: any;
}

export default function UpscaleWrapper({
  children,
  upscaleFactor = 0,
  showBorder = true,
  className = '',
  state
}: UpscaleWrapperProps) {
  if (upscaleFactor === 0) {
    return <div className={className}>{children}</div>;
  }

  return (
    <div className={`relative ${className}`}>
      {children}

      {/* 
        Neon Glow Border Overlay:
        - This overlay uses a multi-layered `boxShadow` for a "cool" neon effect.
        - `pointer-events-none` is crucial to ensure the image below is interactive.
        - `animate-pulse` gives the glow a subtle, dynamic feel.
        - The boxShadow has three parts:
          1. A sharp inner white line to define the image edge.
          2. A vibrant inner purple glow.
          3. A soft outer purple glow that bleeds onto the page.
      */}
      {showBorder && (
        <div
          className={`pointer-events-none absolute inset-0 animate-pulse ${
            !state?.expandContent && 'rounded-md'
          }`}
          style={{
            boxShadow: `
            inset 0 0 0.5px 1px hsl(0 0% 100% / 0.7),
            inset 0 0 7px 2px hsl(280 100% 60% / 0.6),
            0 0 7px 2px hsl(280 100% 60% / 0.4)
          `
          }}
        />
      )}

      {/* 
        The badge is updated to match the neon aesthetic.
      */}
      <div className="absolute left-2 top-2 rounded-full bg-black/60 px-2.5 py-1 text-xs font-bold text-white shadow-[0_0_8px_hsl(280_100%_60%_/_0.7)] backdrop-blur-sm">
        Upscaled {upscaleFactor && `(${upscaleFactor}x)`}
      </div>
    </div>
  );
}
